import {defineStore} from 'pinia'
import Vue from "vue";
import {isEmpty} from "lodash";

/**
 * This is specifically for CategoriesOptions
 * @type {StoreDefinition<"options", {options: [], optionsInitialState: []}, {}, {getOptionsInitialState(): (any|undefined), setOptionsInitialState(*): void, setOptions(*): void, getOptions(): *}>}
 */
export const useOptionsStore = defineStore('options', {
    state: () => {
        let defaultValue = [
            {
                "key": "safesearch",
                "value": 1,
            }, {
                "key": "youtube-restrict",
                "value": 1
            }
        ];
        return {
            /**
             * We have default as 1 as our organization's philosophy is "protection by default".
             */
            options: defaultValue,
            optionsInitialState: JSON.stringify(defaultValue),
        }
    },
    actions: {

        setOptions(options) {
            Vue.set(this, 'options', options);
        },
        getOptions() {
            return this.options;
        },
        getOptionsInitialState() {

            if (typeof this.optionsInitialState !== 'undefined' && !isEmpty(this.optionsInitialState)) {
                return JSON.parse(this.optionsInitialState);
            }

        },
        setOptionsInitialState(options) {

            if (typeof options === 'object') {
                this.optionsInitialState = JSON.stringify(options);
            }

        }
    },
    getters: {}

})
